import { Volume2, VolumeX } from "lucide-react";
import { NAV_LINKS } from "../data/content";
import { scrollToId } from "../utils";

export const Navbar = ({ soundOn, onToggleSound }) => (
  <header className="glass fixed inset-x-0 top-0 z-50" data-testid="main-nav">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
      <button
        type="button"
        onClick={() => scrollToId("home")}
        data-testid="nav-logo"
        className="flex items-center gap-3 bg-transparent"
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#0A192F] font-display text-sm font-black text-[#00E5FF]">
          RS
        </span>
        <span className="hidden font-display text-sm font-bold uppercase tracking-[0.22em] text-[#0A192F] sm:block">
          Rishikesh Sharma
        </span>
      </button>

      <nav className="hidden items-center gap-7 lg:flex">
        {NAV_LINKS.map((l) => (
          <button
            key={l.label}
            type="button"
            onClick={() => scrollToId(l.target)}
            data-testid={`nav-${l.label.toLowerCase()}`}
            className="group relative bg-transparent font-display text-[11px] font-bold uppercase tracking-[0.22em] text-[#0A192F]/70 transition-colors duration-300 hover:text-[#0A192F]"
          >
            {l.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#00BFA5] transition-[width] duration-300 group-hover:w-full" />
          </button>
        ))}
      </nav>

      <button
        type="button"
        onClick={onToggleSound}
        data-testid="sound-toggle-btn"
        aria-label={soundOn ? "Sound off" : "Sound on"}
        className="flex items-center gap-2 rounded-full border border-[#0A192F]/15 bg-white/60 px-4 py-2 text-[#0A192F] transition-colors duration-300 hover:border-[#0A192F]/40"
      >
        {soundOn ? <Volume2 size={15} /> : <VolumeX size={15} />}
        <span className="font-display text-[10px] font-bold uppercase tracking-[0.2em]">
          {soundOn ? "Sound On" : "Sound Off"}
        </span>
      </button>
    </div>
  </header>
);
